import { render } from "./LisaColor.vue?vue&type=template&id=1c8fc284"
import script from "./LisaColor.vue?vue&type=script&lang=js"
export * from "./LisaColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__